<template>
    <v-card>
        <v-data-table
            :headers="headers"
            :items="orders"
            item-key="id"
            :items-per-page="10"
            class="wost-table"
            height="58vh"
            fixed-header
            show-expand
            no-data-text=""
            :single-expand="true"
            :search="search"
        >
            <template v-slot:top>
                <div class="ml-3 mb-2 pt-2">
                    <v-text-field
                        v-model="search"
                        outlined
                        label="Ingrese dni o ruc de cliente"
                        class="text-search-document"
                        dense
                        hide-details
                    >
                    </v-text-field>
                </div>                
                <v-divider></v-divider>
            </template>

            <template v-slot:item.customer="{item}">
                <span>{{ item.customer_name }} {{ item.customer_surname }}</span>
            </template>

            <template v-slot:item.entry_time="{item}">
                <span>{{ item.entry_time | moment("DD/MM/YYYY") }}</span>
            </template>

            <template v-slot:item.pickup_date="{item}">
                <span>{{ item.pickup_date | moment("DD/MM/YYYY") }}</span>
            </template>

            <template v-slot:item.total="{item}">
                <span>{{ item.total | currency('S/') }}</span>
            </template>

            <template v-slot:item.total_payment="{item}">
                <span class="total-payment">{{ item.total_payment | currency('S/') }}</span>
            </template>

            <template v-slot:item.total_pending="{item}">
                <span class="total-pending">{{ item.total_pending | currency('S/') }}</span>
            </template>

            <template v-slot:item.status="{item}">
                <span :class="'order-status order-status-' + item.status.toLowerCase().replace(' ', '-')">
                    <v-icon size="8" :class="'mr-1 order-status-' + item.status.toLowerCase().replace(' ', '-')">fas fa-circle</v-icon> 
                    {{ item.status | uppercase }}
                </span>
            </template>

            <template v-slot:item.actions="{item}">
                <v-btn
                    color="green"
                    dark
                    small 
                    @click="handleDeliverOrder(item)">
                    Entregar
                </v-btn>

                <v-btn 
                    class="ml-2"
                    small
                    color="red"
                    dark
                    @click="handleCancelOrder(item)">
                    Anular
                </v-btn>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="wost-td-expanded">
                    <template>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-card>
                                        <v-simple-table dense class="table-kardex">
                                            <thead class="table-kardex-head">
                                                <tr>
                                                    <th>Producto</th>
                                                    <th>Cantidad</th>
                                                    <th>Precio Und.</th>
                                                    <th>Descuento</th>
                                                    <th>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody class="table-kardex-body">
                                                <tr v-for="product in item.detail" :key="product.id">
                                                    <td>
                                                        <v-icon v-if="product.is_bonus" color="amber" size="16" class="mr-2">
                                                            fas fa-gift
                                                        </v-icon>
                                                        <span>
                                                            {{ product.name }}
                                                        </span>
                                                    </td>
                                                    <td>{{ product.quantity }}</td>
                                                    <td>{{ product.base_price | currency('S/') }}</td>
                                                    <td>{{ product.discount_value | currency('S/') }}</td>
                                                    <td>{{ product.subtotal | currency('S/') }}</td>
                                                </tr>
                                            </tbody>
                                        </v-simple-table>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>
                </td>
            </template>

        </v-data-table>

        <payment-form ref="paymentForm"/>
    </v-card>
</template>

<script>

import {mapActions, mapState} from 'vuex';
import PaymentTools from '../../helpers/PaymentTools.js';
import PaymentForm from '../../components/Payment/PaymentForm';

import {APIService} from '@/APIService';
const apiService = new APIService();

export default {
    name: 'Listorders',
    components: {
        PaymentForm
    },
    data () {
        return {
            search: '',
            headers: [
                { text: 'CLIENTE', value: 'customer', sortable: false, class: 'header-table' },
                { text: 'RUC/DNI.', value: 'customer_document', sortable: false, class: 'header-table' },
                { text: 'F. PEDIDO', value: 'entry_time', sortable: false, class: 'header-table', filterable: false, },
                { text: 'F. ENTREGA', value: 'pickup_date', sortable: false, class: 'header-table', filterable: false, },
                { text: 'TOTAL PEDIDO', value: 'total', sortable: false, align: 'end', class: 'header-table', filterable: false, },
                { text: 'TOTAL PAGADO', value: 'total_payment', sortable: false, align: 'end', class: 'header-table', filterable: false, },
                { text: 'TOTAL PENDIENTE', value: 'total_pending', sortable: false, align: 'end', class: 'header-table', filterable: false, },
                { text: 'ESTADO', value: 'status', sortable: false, class: 'header-table', filterable: false, },              
                { text: '', value: 'actions', sortable: false, align: 'end', class: 'header-table', filterable: false, }
            ],
        }
    },
    computed: {
        ...mapState('orders', [
            'orders',
            'order'
        ]),
        ...mapState('cash', [
            'cashCurrent'
        ]),
        ...mapState('payment', [
            'listProducts',
            'amount_igv'
        ]),
        ...mapState('sales', [
            'orderId'
        ]),
    },
    methods: {
        ...mapActions('orders', [
            'getToDispatch',
            'selectOrder'
        ]),
        ...mapActions('payment', [
            'runSetListProducts',
            'runSetCustomer',
            'runSetOrderIdPay',
            'runSetSubtotal',
            'runSetTotal',
            'runSetAmountIgv',
            'setTotalPayment',
            'setTotalPending',
            'setTypeOrder',
            'setTotalOrder',
            'setDeliverOrder'
        ]),
        handleDeliverOrder (order) {
            if (order.total_pending !== 0) {
                //mostrar formulario de pago
                if (!this.existCashOpen()) {
                    this.$swal({
                        text: "Caja esta cerrada, no puede realizar pago.",
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Aceptar"
                    });
                } else {
                    this.showFormToPayment(order);
                }
            } else {
                this.changeStatus(order, 'Entregado', 'entregar');
            }
        },
        handleCancelOrder (order) {
            this.changeStatus(order, 'Anulado', 'anular');
        },
        existCashOpen () {
            let exist = true;
            if (this.cashCurrent == null || this.cashCurrent == '') {
                exist = false;
            }
            return exist;
        },
        showFormToPayment(order) {
            this.selectOrder(order);
            this.runSetOrderIdPay(null)
            this.runSetOrderIdPay(order.id)
            this.runSetSubtotal(order.subtotal)
            this.runSetAmountIgv(order.igv)
            this.setTotalOrder(order.total);
            this.runSetTotal(order.total_pending)
            this.runSetListProducts([])
            this.runSetListProducts(PaymentTools.prepareProductList('orders', order.detail))
            this.runSetCustomer(order.customer);
            this.setTypeOrder(order.type_order);
            this.setTotalPayment(order.total_payment);
            this.setTotalPending(order.total_pending);
            this.setDeliverOrder(true);
            this.$refs.paymentForm.showForm()
        },
        changeStatus(order, newStatus, action){
            this.$swal({
                    title: "¿Desea confirmar?",
                    text: "Confirma que desea " + action + " el pedido.",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Confirmar",
                    cancelButtonText: "Cancelar",
                }).then((result) => {
                    if(result.value){
                        if(result.value === true){
                            let orderChange = {
                                order_id: order.id,
                                status: newStatus
                            }
                            apiService.changeStatusOrder(orderChange).then((response) => {
                                this.getToDispatch();
                                this.$notify({
                                    group: 'foo',
                                    type: 'success',
                                    title: 'RESULTADO DE ACCIÓN REALIZADA',
                                    text: 'El cambio de estado se realizó de manera correcta!'
                                });
                            });
                        }
                    }                    
                })
        },
    },
    created () {
        this.setDeliverOrder(false);
        this.getToDispatch();
    }
}
</script>

<style scoped>
.w-title-table{
    display: block;
}

.total-payment{
    color: #4CAF50;
    font-weight: 600;
}

.total-pending{
    color: #F44336;
    font-weight: 600;
}

.v-data-table tbody tr.v-data-table__expanded__content{
    webkit-box-shadow: none !important;
    box-shadow: none !important;
    background-color: #f4f6f8 !important;
}

.text-search-document{
    width: 30% !important;
}
</style>